import { render } from "./InterfaceDesignerToolbar.vue?vue&type=template&id=4883bd4f&scoped=true"
import script from "./InterfaceDesignerToolbar.vue?vue&type=script&lang=js"
export * from "./InterfaceDesignerToolbar.vue?vue&type=script&lang=js"

import "./InterfaceDesignerToolbar.vue?vue&type=style&index=0&id=4883bd4f&scoped=true&lang=scss"

import exportComponent from "/tmp/b45e941b-d1ac-4235-8dba-072c0c886010/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4883bd4f"]])

export default __exports__